import {
    DocumentationService,
    ForgeService,
    IdentityService,
    ProjectsService,
    NotificationsService,
    // DataSourcesService,
    // WorkOrdersService,
    // AssetsService,
    AssetsInformationService,
    PowerBIService,
    RuleSetsService,
    ApiPanelsService,
    PowerAppsService,
    ChatMessageService,
    AssetControlService,
    SignalsService,
    SimliService,
} from "./APIClient";
import { APIConfig } from "../auth/AuthorizeService";

export const forgeService = new ForgeService(APIConfig);
export const identityService = new IdentityService(APIConfig);
export const projectsService = new ProjectsService(APIConfig);
export const documentationService = new DocumentationService(APIConfig);
// export const assetsService = new AssetsService(APIConfig);
export const assetsInformationService = new AssetsInformationService(APIConfig);
export const notificationsService = new NotificationsService(APIConfig);
// export const dataSourcesService = new DataSourcesService(APIConfig);
// export const workOrdersService = new WorkOrdersService(APIConfig);
export const powerBIService = new PowerBIService(APIConfig);
export const ruleSetsService = new RuleSetsService(APIConfig);
export const apiPanelsService = new ApiPanelsService(APIConfig);
export const powerAppsService = new PowerAppsService(APIConfig);
export const chatMessageService = new ChatMessageService(APIConfig);
export const assetControlService = new AssetControlService(APIConfig);
export const signalsService = new SignalsService(APIConfig);
export const simliService = new SimliService(APIConfig);
